import React from "react";
import { 
    PageWrapper,
    ContentWrapper,
    LogoContainer,
    CompanyName,
    Description,
    LaunchDate,
 } from "./elements";

function ComingSoonPage() {
  return (
    <PageWrapper>
      <ContentWrapper>
        <LogoContainer>
        </LogoContainer>
        <CompanyName>Nelson Development</CompanyName>
        <Description>Be Brilliant</Description>
        <LaunchDate>Coming Soon 2024</LaunchDate>
      </ContentWrapper>
    </PageWrapper>
  );
}

export default ComingSoonPage;